var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"churn-button",on:{"click":_vm.openChurnFlow}},[_c('span',{staticClass:"button-title"},[_vm._v("סגירת חשבון ומחיקת פרטים")]),_vm._v(" "),_c('span',{staticClass:"button-icon fa fa-chevron-left"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfc89d24","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/navigation-pages/account-settings/components/ChurnButton.vue
// module id = null
// module chunks = 